import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=50986eb3&scoped=true&"
import script from "./TypeForm.vue?vue&type=script&lang=ts&"
export * from "./TypeForm.vue?vue&type=script&lang=ts&"
import style0 from "./TypeForm.vue?vue&type=style&index=0&id=50986eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50986eb3",
  null
  
)

export default component.exports